import { connect } from 'react-redux';

import {requestTickets,requestContact,addTicket,requestTicket,addComment,requestComments} from '../modules/support';

import TicketList from '../components/TicketList';

const mapDispatchToProps = {
  requestTickets,
  requestContact,
  addTicket,
  requestTicket,
  addComment,
  requestComments
};

const mapStateToProps = (state, ownProps) => ({
  tickets: state.support.tickets
});

export default connect(mapStateToProps, mapDispatchToProps)(TicketList);



// WEBPACK FOOTER //
// src/routes/support/containers/SupportContainer.js